import '../scss/layout.scss';
import { Carousel } from 'antd';

import showcase1 from '../assets/dtp/dtp-showcase-1.png'
import showcase2 from '../assets/dtp/dtp-showcase-2.png'
import showcase3 from '../assets/dtp/dtp-showcase-3.png'

export const ImgSlider = () =>{
    return(
        <div className='slider'>
          <Carousel afterChange={(e)=>null} arrows autoplay draggable>
            <div className='container'>
                <img src={showcase1} className={'img'} alt='Digital Transformation Showcase'/>
            </div>
            <div className='container'>
                <img src={showcase2} className={'img'} alt='Digital Transformation Showcase'/>
            </div>
            <div className='container'>
                <img src={showcase3} className={'img'} alt='Digital Transformation Showcase'/>
            </div>
        </Carousel>
        </div>
    )
}